export const TYPES = {
  ADD_FLASH: "ADD_FLASH",
  CLOSE_FLASH: "CLOSE_FLASH",
  CLEAR_FLASHES: "CLEAR_FLASHES",
};

export const addFlash = (message, { key, ...options } = {}) => {
  const id = key || new Date().getTime() + Math.random();
  const flash = {
    key: id,
    variant: "light",
    preventDuplicate: true,
    ...options,
    message,
  };

  return { type: TYPES.ADD_FLASH, payload: flash };
};

export const closeFlash = (key) => {
  return { type: TYPES.CLOSE_FLASH, payload: key };
};

export const clearFlashes = () => {
  return { type: TYPES.CLEAR_FLASHES };
};
